export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDR1TseOJwdmzVI6x96aOa8CKphm60pFmY",
  authDomain: "recipebook-a6016.firebaseapp.com",
  projectId: "recipebook-a6016",
  storageBucket: "recipebook-a6016.firebasestorage.app",
  messagingSenderId: "815844237669",
  appId: "1:815844237669:web:81d040633bc8a10894c18c",
  measurementId: "G-MSV0611FVH"
};

export const API_BASE = 'http://localhost:3003';

export const CATEGORIES = [
  { value: 'breakfast', label: 'Breakfast & Brunch', emoji: '🍳' },
  { value: 'lunch', label: 'Lunch', emoji: '🥗' },
  { value: 'dinner', label: 'Dinner', emoji: '🍽️' },
  { value: 'dessert', label: 'Desserts', emoji: '🍰' },
  { value: 'snack', label: 'Snacks', emoji: '🍿' },
  { value: 'drinks', label: 'Drinks', emoji: '🥤' },
  { value: 'sides', label: 'Sides', emoji: '🥦' },
];

export const TAGS = [
  'Healthy', 'Indulgent', 'Quick', 'Easy', 'Vegetarian', 'Vegan',
  'Gluten-Free', 'Dairy-Free', 'Spicy', 'Comfort Food', 'Meal Prep',
  'Date Night', 'Kid-Friendly', 'High Protein', 'Low Carb',
];

export const DIFFICULTY = [
  { value: 'easy', label: 'Easy', color: '#66bb6a' },
  { value: 'medium', label: 'Medium', color: '#ffa726' },
  { value: 'hard', label: 'Hard', color: '#ef5350' },
];

export const CATEGORY_GRADIENTS = {
  breakfast: 'linear-gradient(135deg, #f59e0b, #d97706)',
  lunch: 'linear-gradient(135deg, #6bb07a, #4a8a58)',
  dinner: 'linear-gradient(135deg, #ef4444, #b91c1c)',
  dessert: 'linear-gradient(135deg, #ec4899, #9333ea)',
  snack: 'linear-gradient(135deg, #f97316, #ea580c)',
  drinks: 'linear-gradient(135deg, #06b6d4, #0891b2)',
  sides: 'linear-gradient(135deg, #84cc16, #65a30d)',
};
